export default __webpack_public_path__ + "static/media/kako_funkcionisu_1.c9a4a79b.png";